// frontend/src/components/OwnerDashboard/ComplianceGauge.js
// Gauge + the breakdown that produced it, so the score is explainable.

const R = 50;
const C = 2 * Math.PI * R; // ≈314

export default function ComplianceGauge({ health }) {
  return (
    <div className="rounded-2xl border border-[#241F1B] bg-gradient-to-b from-[#17140F] to-[#131110] px-[18px] py-[17px]">
      <p className="text-[10.5px] uppercase tracking-[.16em] text-[#6E665C]">Indice de conformité</p>

      <div className="flex items-center gap-4 mt-3">
        <div className="relative w-[104px] h-[104px] shrink-0">
          <svg viewBox="0 0 120 120" className="w-[104px] h-[104px] -rotate-90">
            <circle cx="60" cy="60" r={R} fill="none" stroke="#241F1B" strokeWidth="9" />
            <circle cx="60" cy="60" r={R} fill="none" strokeWidth="9" strokeLinecap="round"
                    stroke={health.scoreColor}
                    strokeDasharray={`${(health.score / 100) * C} ${C}`} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="font-['Space_Grotesk',sans-serif] text-[26px] font-semibold tracking-[-.03em] leading-none tabular-nums text-[#F4F1EA]">
              {health.score}<span className="text-sm text-[#8F877B]">%</span>
            </span>
            <span className="text-[9px] uppercase tracking-[.12em] mt-[3px]" style={{ color: health.scoreColor }}>
              {health.scoreLabel}
            </span>
          </div>
        </div>

        <div className="flex-1 flex flex-col gap-2.5">
          {health.breakdown.map((b) => (
            <div key={b.label}>
              <div className="flex justify-between text-[11px] text-[#8F877B] mb-1">
                <span>{b.label}</span><span className="tabular-nums">{b.num}</span>
              </div>
              <span className="block h-1 rounded-[3px] bg-[#241F1B] overflow-hidden">
                <span className="block h-full rounded-[3px]" style={{ width: b.pct, background: b.color }} />
              </span>
            </div>
          ))}
        </div>
      </div>

      <p className="mt-3.5 pt-3 border-t border-[#241F1B] text-[11.5px] text-[#8F877B] leading-[1.5]">
        {health.insuranceGap === 0
          ? 'Toutes les assurances sont à jour.'
          : <>Régulariser les {health.insuranceGap} assurance{health.insuranceGap > 1 ? 's' : ''} ferait passer l’indice à{' '}
              <span className="text-[#74A98D] font-semibold">{health.uplift} %</span>.</>}
      </p>
    </div>
  );
}
